export function getScrollParent(element: HTMLElement): HTMLElement | null {
  let parent = element.parentElement

  while (parent) {
    const { overflowY } = getComputedStyle(parent)
    if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
      return parent
    }
    parent = parent.parentElement
  }

  return null
}
